import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as bootstrap from "bootstrap";
import * as Vue from 'vue';
import dcautocomplete from "./../Shared/dcautocomplete.vue";
import { createPinia } from 'pinia';
export class IDInfPlier {
    public idinf: number = 0;
    public active: boolean = false;
}

let g_idinfs: IDInfPlier[] = [];

const mixin = defineComponent({
    data() {
        return {
            infidmap: null as any,
            allhid: false,
            m_modal: null as bootstrap.Modal | null,
            urlconstructeur: ""
        };
    },
    mounted() {
        this.infidmap = new Map(g_idinfs.map(key => [key.idinf, key.active] as [number, boolean]));
    },
    methods: {
        PlierAllInfs(idinf:number) {
            if (this.infidmap == null)
                return;
            if (this.infidmap.size < 1)
                return;
            let firstinf: boolean;
            if (idinf == 0)
                firstinf = this.infidmap.entries().next().value[1];
            else
                firstinf = this.infidmap.get(idinf);
            for (const [key, value] of this.infidmap.entries()) {
                this.infidmap.set(key, !firstinf);
            }
        },
        SetAllHid(event: any) {
            event.preventDefault();
            this.allhid = true;
        },
        PlierInf(idinf: number) {
            if (this.infidmap!=null)
            this.infidmap.set(idinf, !this.infidmap.get(idinf));
        },
        ScrollBlocInf(idinf: number) {
            let elt = null;
            if (idinf == 0)
                elt = document.getElementById('firstinf');
            else
                elt = document.getElementById('blocinf_' + idinf);
            if (elt != null)
                window.scrollTo(0, elt.offsetTop - 90);
        },
        SetUrlCategorie(url: string) {
            this.urlconstructeur = url;
        },

        ConstructeursResults(input: string) {
            let url: string = "/api/v1.0/drivers/SearchConstructeur?query=" + input;
            return url;
        },

        ConstructeursDisplay(result: any) {
            return result.label;
        },

        ConstructeursSelected(selectitem: any) {
            let url = this.urlconstructeur.replace("-1", selectitem.value).replace("-2", selectitem.display);
            location.href = url;
        },

        OpenModal(event: any) {
            event.preventDefault();
            const elt = document.getElementById('dcinfosdriversdowndlg');
            if (elt !== null) {
                this.m_modal = new bootstrap.Modal(elt, {
                });
                this.m_modal.show();
            }
            return true;
        },

        FermerModal(event: any, url: string) {
            event.preventDefault();
            if (this.m_modal !== null)
                this.m_modal.hide();
            location.href = url;
            return true;
        }
    }
});


export class GetInformationDriverComponent {
    public Init(idinfs: IDInfPlier[]) {
        g_idinfs = idinfs;
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.component("autocomplete", dcautocomplete);
        app.mount('#rootpage');
    }
}

(<any>(window)).GetInformationDriverComponent = function () { return new GetInformationDriverComponent(); };